import React from "react";

import InvestYieldState from "./InvestYieldState";

export default function InvestYieldEmptyState(props) {
  return <InvestYieldState {...props} variant="empty" />;
}
